import React from "react"
import {
  LevelProgressBar,
  LevelProgressData,
} from "@love-irish/adventure-level-progress"

export interface ProfileCurrentLevelProps {
  /** The canonical `levelProgress` object (profile, skill, or resource). */
  progress?: LevelProgressData | null
  className?: string
}

/**
 * Thin wrapper over the standard {@link LevelProgressBar}, kept as the named entry point some
 * surfaces import. Pass the subject's canonical `levelProgress`.
 */
export const ProfileCurrentLevel: React.FC<ProfileCurrentLevelProps> = ({
  progress,
  className,
}) => <LevelProgressBar progress={progress} className={className} />

export default ProfileCurrentLevel
